import 'telia-front-react/styles/telia.css';
import 'telia-front-react/styles/global.css';
import('./bootstrap');
